exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".jiraProgress-6ce7a{font-size:14px;color:#595959}", ""]);

// Exports
exports.locals = {
	"jiraProgress": "jiraProgress-6ce7a"
};